import { useInView } from "react-intersection-observer"
import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import heroHouse1200w from "images/hero-house-1200w.jpg"
import heroHouse2400w from "images/hero-house-2400w.jpg"
import ScrollCta from "../ScrollCta"
import SplashCtaDropdown from "../SplashCtaDropdown"

const SplashHero: React.FC = () => {
  const [ref, inView] = useInView({ threshold: 0 })

  return (
    <section
      className={cx({
        [styles.splashHero]: true,
        [styles.inView]: inView,
      })}
      ref={ref}
    >
      <div className={styles.figure}>
        <img
          className={styles.image}
          src={heroHouse1200w}
          srcSet={`${heroHouse2400w} 2400w, ${heroHouse1200w} 1200w`}
          sizes="100vw"
          alt="Better House"
        />
      </div>
      <div className={styles.pagePadding}>
        <div className={styles.message}>
          <h1 className={styles.heading}>Get a Better Mortgage.</h1>
          <p className={styles.subhead}>
            One that respects your time, your circumstances, and your wallet.
          </p>
        </div>
        <SplashCtaDropdown />
        <ScrollCta cta="Learn More" />
      </div>
    </section>
  )
}

export default SplashHero
